import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface SendSMSResultDialogData {
  status: 'success' | 'error';
  message: string;
}

@Component({
  selector: 'ap-send-sms-result-dialog',
  templateUrl: './send-sms-result.dialog.html',
  styleUrls: ['./send-sms-result.dialog.scss']
})
export class SendSMSResultDialog {
  constructor(@Inject(MAT_DIALOG_DATA) public data: SendSMSResultDialogData) {}
}
